import { Car } from '../components/CarCard';

export const carsData: Car[] = [
  {
    id: '3119',
    title: 'Coming Soon – 1998 BMW AC Schnitzer ACS5 Sport',
    year: 1998,
    make: 'BMW',
    model: 'AC Schnitzer ACS5 Sport',
    mileage: '219,000 kms',
    price: 'Available May 1st, 2026',
    description: '',
    features: [
      'AC Schnitzer 3.2 Liter S5 Engine',
      'Clean Car with no underbody rust',
      'Runs and Drives great',
      'Originally Auto, converted to ZF 5 Speed',
      'New clutch, E60 short shifter, all bushings, master cyl, slave cyl',
      'Engine and Transmission fluid changed',
      'Complete ACS5 Body kit',
      'Upgraded brakes',
      'Coilover suspension kit',
      'New Bosch Ignition coils + spark plugs',
      'New valve cover gasket',
      'Rebuilt Vanos system with rattle kit',
      'All intake seals and gaskets replaced',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2024/04/whatsapp-image-2024-06-14-at-23.17.21.jpeg'],
    status: 'available',
    datePosted: '2024-04-02',
  },
  {
    id: '2976',
    title: '1991 Mercedes 190E 2.5-16 Cosworth 16v',
    year: 1991,
    make: 'Mercedes',
    model: '190E 2.5-16 Cosworth 16v',
    mileage: '189,000 kms',
    price: 'CAD 45,000 + HST',
    description: '',
    features: [
      '17″ AMG 3 piece Wheels',
      'Clean Car with no underbody rust',
      'Runs and Drives great',
      'Classic collector car',
      'Rare houndstooth interior',
      '2.5 Liter Cosworth Engine with double row timing chain',
      'Head fully rebuilt — new valves, guides, seals',
      'Rebuilt fuel distributor',
      'Transmission fluid, filter and gasket replaced',
      'Rebuilt fuel pump relay',
      'Coolant replaced',
      'Rebuilt ECU',
    ],
    issues: [
      'Front accident repaired',
    ],
    images: ['https://jdm.net/wp-content/uploads/2024/02/1990_mercedes-benz_190e_2-5-16_1535642411e7dff9f98764dadsc_1724.jpg'],
    photoLink: 'https://photos.app.goo.gl/G3eCQUcKX392FEfB6',
    status: 'available',
    datePosted: '2024-02-24',
  },
  {
    id: '2963',
    title: '1999 Mitsubishi Lancer Evolution VI',
    year: 1999,
    make: 'Mitsubishi',
    model: 'Lancer Evolution VI',
    mileage: '156,000 kms',
    price: 'CAD 30,000 + HST',
    description: '',
    features: [
      '2.0 Liter Turbo 4G63 Engine, AWD',
      'Runs and drives well',
    ],
    issues: [
      'Needs brakes, tires etc.',
      'Light hail damage on roof and hood',
    ],
    images: ['https://jdm.net/wp-content/uploads/2024/02/20240223_172628.jpg'],
    photoLink: 'https://photos.app.goo.gl/QK4ZwX2sbFfAtrxV9',
    status: 'available',
    datePosted: '2024-02-23',
  },
  {
    id: '2951',
    title: '1998 Mitsubishi Evo V',
    year: 1998,
    make: 'Mitsubishi',
    model: 'Evo V',
    mileage: '168,000 kms',
    price: 'CAD 30,000 + HST',
    description: '',
    features: [
      '4G63T 2.0 Liter Turbo Engine',
      'Evo 6 wheels',
      'Aftermarket catback exhaust',
      'Mishimoto Radiator',
      'New Timing Belt, Water pump, Serpentine belt',
      'HKS Cams',
    ],
    issues: [
      'Needs brakes, tires, tune',
    ],
    images: ['https://jdm.net/wp-content/uploads/2024/03/20240303_175950.jpg'],
    photoLink: 'https://photos.app.goo.gl/mp9kbZEbGT9qN5Dr8',
    status: 'available',
    datePosted: '2024-02-20',
  },
  {
    id: '1848',
    title: '1987 Mercedes 2.3-16 Cosworth',
    year: 1987,
    make: 'Mercedes',
    model: '2.3-16 Cosworth',
    mileage: '98,000 miles (true mileage unknown)',
    price: 'CAD 40,000 + HST',
    description: '',
    features: [
      'Mercedes 2.3-16v Cosworth engine',
      'USA Import',
      'New glass and trim-out repaint',
      'Runs and drives great — a ton of fun to drive',
      'New SLS Accumulators, rebuilt SLS Pump',
      'Front Bilstein shocks',
      'Engine oil — Castrol Synthetic 5W40',
      'Evo 1 16″ Gullideckel wheels with new tires',
      '208,000 kms recorded in Carfax 2015',
    ],
    issues: [
      'Needs new brakes',
      'True mileage unknown',
      'Front right fender replaced',
    ],
    images: ['https://jdm.net/wp-content/uploads/2023/05/20230512_191506.jpg'],
    photoLink: 'https://photos.app.goo.gl/JHHo8twWAQJZNfct7',
    status: 'available',
    datePosted: '2023-03-22',
  },
  {
    id: '1210',
    title: '1994 Mitsubishi Lancer Evolution II',
    year: 1994,
    make: 'Mitsubishi',
    model: 'Lancer Evolution II',
    mileage: '102,000 kms',
    price: 'Contact Us',
    description: '',
    features: [
      'Low mileage — 102,000 original kms',
      'Runs and drives great, lots of power',
      'Smooth running engine',
      'New spark plugs and ignition wires',
      'New timing belt and tensioner',
      'Engine oil — Castrol Synthetic 5W40',
      'Transmission oil — Motul 75W90',
    ],
    issues: [
      'Left side repainted and faded — will need cut and polish',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/07/dsc8926.jpg'],
    status: 'available',
    datePosted: '2021-07-03',
  },
  {
    id: '947',
    title: '1988 BMW M3',
    year: 1988,
    make: 'BMW',
    model: 'M3',
    mileage: '',
    price: 'Contact Us',
    description: '',
    features: [
      'Street legal race car',
      '321 bhp S50B32 EuroSpec Engine swap',
      'E36 M3 5-speed ZF transmission',
      'UUC Evo 3 shortshift kit + double shear selector rod',
      'UUC Stage 2 Lightened 8.5lb flywheel',
      'E34 M5 clutch',
      'E30 M3 driveshaft',
      '3.25 OS Giken LSD differential',
      'Fluidyne all-aluminum radiator + Mishimoto electric fan',
      'Setrab oil cooler',
      'Walbro 255lph fuel pump',
      'Massive Brakes Rally big brake kit — Wilwood 6-piston calipers, 300x32mm slotted rotors',
      'Manual brake conversion — Tilton Series 75 master cylinders',
      'Kosei K1 15×8 wheels with Toyo R1R 225/45 R15 tires',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2021/01/5082376225_3a10ef491c_o.jpg'],
    photoLink: 'https://photos.app.goo.gl/c8wxAiC33gtWDRwH9',
    status: 'available',
    datePosted: '2021-01-14',
  },
  {
    id: '479',
    title: '1991 BMW 325i M-Tech 2 Wagon',
    year: 1991,
    make: 'BMW',
    model: '325i M-Tech 2 Wagon',
    mileage: '102,000 kms',
    price: 'Contact Us',
    description: '',
    features: [
      'MTech II Package',
      '102,000 kms (64,000 miles)',
      'Clean Car with zero underbody rust',
      'Rare Lagun Grün metallic color',
      'Slick Top long roof (no sunroof)',
      'Over $25,000 in repair receipts',
      'Aluminum control arms',
      'The nicest and tightest running E30 we\'ve ever had',
      'Engine oil — Mobil1 5W40, transmission — Royal Purple',
      'New driveshaft flexdisc and center support bearing',
      'New master and slave clutch cylinders',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2019/09/dsc_6332-1.jpg'],
    photoLink: 'https://photos.app.goo.gl/Mkja4E8ughn9aTYL9',
    status: 'available',
    datePosted: '2019-09-04',
  },
  {
    id: '1839',
    title: '2004 Audi RS6',
    year: 2004,
    make: 'Audi',
    model: 'RS6',
    mileage: '114,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'Twin Turbo AWD 4.2 liter V8',
      '444 bhp — Runs and Drives great',
      'Solar sunroof option',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2023/03/screen-shot-2023-03-19-at-7.40.45-pm.png'],
    status: 'sold',
    datePosted: '2023-03-19',
  },
  {
    id: '1495',
    title: '1997 BMW M3 EuroSpec 321bhp',
    year: 1997,
    make: 'BMW',
    model: 'M3 EuroSpec',
    mileage: '105,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'S50B32 3.2L ITB Engine — 321 bhp',
      '6 Speed Gearbox',
      'Beautiful Estoril Blue color',
      'Slickroof (No Sunroof)',
      'M Rain cloth interior',
      'Clean Car with no undercarriage rust',
      'Oil change, new spark plugs, intake seals replaced',
      'Rebuilt Vanos with rattle kit and S62 diaphragm spring upgrade',
      'Valve clearance checked, even compression in all cylinders',
      'New rear trailing arm bushings, knock sensors, oxygen sensors',
      'New crankcase ventilation hoses',
    ],
    issues: [
      'Needs new tires',
      'Needs suspension refresh',
      'ABS light is on',
      'Fuel gauge shows incorrect reading',
      'Interior door panels and roof liners delaminating',
    ],
    images: ['https://jdm.net/wp-content/uploads/2024/02/whatsapp-image-2024-02-04-at-5.25.27-pm.jpeg'],
    status: 'sold',
    datePosted: '2022-02-08',
  },
  {
    id: '1456',
    title: '1986 Alpina C2 2.5',
    year: 1986,
    make: 'Alpina',
    model: 'C2 2.5',
    mileage: '156,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'Full ground up restoration',
      'Rare 2 door coupe',
      '5 speed transmission',
      'Runs and drives excellent',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2021/12/dsc0214.jpg'],
    status: 'sold',
    datePosted: '2021-12-24',
  },
  {
    id: '1410',
    title: '1994 Mitsubishi Lancer Evo II',
    year: 1994,
    make: 'Mitsubishi',
    model: 'Lancer Evo II',
    mileage: '191,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'New glass and trim-out repaint, new windshield installed',
      'OEM Evo 3 body kit',
      'New stock clutch kit',
      'Engine oil — Castrol Synthetic 5W40',
      'Transmission and center diff fluids changed',
      'New brake rotors and pads all around',
    ],
    issues: [
      'Accident history from Japan — driver quality car, not a collector',
      'Undercarriage rust',
      'No A/C, missing trunk carpeting',
      'Auction Grade R',
      'Ran with low oil due to leaking oil cooler — engine may need rebuild',
    ],
    images: ['https://jdm.net/wp-content/uploads/2022/04/whatsapp-image-2022-04-09-at-4.40.48-pm-7.jpeg'],
    status: 'sold',
    datePosted: '2021-11-27',
  },
  {
    id: '1405',
    title: '1996 Mitsubishi Lancer Evo IV',
    year: 1996,
    make: 'Mitsubishi',
    model: 'Lancer Evo IV',
    mileage: '',
    price: 'Sold',
    description: '',
    features: [
      'AWD Turbo 4G63 Engine',
      'Runs and Drives great, lots of power',
      'Good and even compression',
      'Oil changed — Castrol Synthetic 5W40',
      'Auction Grade 4',
    ],
    issues: [
      'Dents and scratches on body',
      'Paint in poor condition',
      'Muffler leak',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/11/dsc9967.jpg'],
    photoLink: 'https://photos.app.goo.gl/QvhCWsX9RWqvQGQz9',
    status: 'sold',
    datePosted: '2021-11-27',
  },
  {
    id: '1384',
    title: '1991 Mercedes 190E 2.5-16v Cosworth',
    year: 1991,
    make: 'Mercedes',
    model: '190E 2.5-16v Cosworth',
    mileage: '79,500 kms',
    price: 'Sold',
    description: '',
    features: [
      'Clean, low mileage Cosworth 2.5-16v',
      'Automatic Transmission',
      'Rust free underbody',
      'Collector quality',
      'Rare Houndstooth Recaro interior',
      'Oil changed — Castrol 5W40 Synthetic',
      'Rear SLS accumulators replaced',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2021/11/dsc9748.jpg'],
    photoLink: 'https://photos.app.goo.gl/VCPfa8kt4bo4q4K5A',
    status: 'sold',
    datePosted: '2021-11-13',
  },
  {
    id: '1359',
    title: '1990 BMW 320i E30',
    year: 1990,
    make: 'BMW',
    model: '320i E30',
    mileage: '24,233 kms',
    price: 'Sold',
    description: '',
    features: [
      'Very clean with zero rust',
      'Runs and drives smooth',
      'Rare Slicktop (no sunroof)',
      'A/C and heat works',
      'All 3 V-belts replaced',
    ],
    issues: [
      'Paint faded — clear coat sun damaged on roof, trunk and hood',
      'True mileage unknown',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/10/dsc9473.jpg'],
    photoLink: 'https://photos.app.goo.gl/Y79mqejEtyr9VHmv9',
    status: 'sold',
    datePosted: '2021-10-22',
  },
  {
    id: '1318',
    title: '1999 Mitsubishi Lancer Evolution VI',
    year: 1999,
    make: 'Mitsubishi',
    model: 'Lancer Evolution VI',
    mileage: '121,500 kms',
    price: 'Sold',
    description: '',
    features: [
      '2.0 Liter Turbo 4G63 Engine, AWD',
      'Runs and drives well',
      'Low mileage — 121,500 kms',
      'Very clean car, one of the nicest Evos we have seen',
      'New 18″ Rota Wheels and tires',
      'Auction Grade 4',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2021/09/dsc9135.jpg'],
    status: 'sold',
    datePosted: '2021-09-18',
  },
  {
    id: '1175',
    title: '1995 Nissan Skyline GTR V-Spec',
    year: 1995,
    make: 'Nissan',
    model: 'Skyline GTR V-Spec',
    mileage: '118,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'Rust free, clean underbody',
      '118,000 original kms',
      'Panasport 18″ 2 piece wheels with Nitto Invos',
      'All oils changed — Castrol 10W30 engine, Royal Purple diffs, Redline D4 transfer, Redline MT90 trans',
      'Comes with CarVX report from Japan — Auction Grade R',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2021/06/dsc8706.jpg'],
    photoLink: 'https://photos.app.goo.gl/ccb89Azb6GJYQgHn9',
    status: 'sold',
    datePosted: '2021-06-15',
  },
  {
    id: '1142',
    title: '2000 Mitsubishi Lancer Evolution Tommi Makinen Edition',
    year: 2000,
    make: 'Mitsubishi',
    model: 'Lancer Evolution TME',
    mileage: '95,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'Rare Tommi Mäkinen Edition',
      'Original Red SCP (Special Coloring Package)',
      'Very rare Left Hand Drive European import — less than 50 LHD made in Red',
      'Limited production',
      '286 hp Turbo Engine, 5 Speed gearbox',
      'Collector car',
    ],
    issues: [],
    images: ['https://jdm.net/wp-content/uploads/2022/02/dsc0377.jpg'],
    photoLink: 'https://photos.app.goo.gl/wXXjEjgmKcfTTTyF8',
    status: 'sold',
    datePosted: '2021-05-19',
  },
  {
    id: '1103',
    title: '1999 Mitsubishi Evolution VI',
    year: 1999,
    make: 'Mitsubishi',
    model: 'Evolution VI',
    mileage: '91,500 kms',
    price: 'Sold',
    description: '',
    features: [
      '2.0 Liter Turbo 4G63 Engine, AWD',
      'Low mileage — 91,500 kms',
      'New Stage 2 clutch',
      'HKS Hipermax Pro Adjustable suspension',
      'New timing belt, balance belt and tensioners',
      'New serpentine belt and spark plugs',
      'Engine oil — Castrol Synthetic 5W40',
      'Perfect compression — 180-180-182-180',
    ],
    issues: [
      'Front ball joints need replacement',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/05/whatsapp-image-2021-05-01-at-9.49.34-pm.jpeg'],
    status: 'sold',
    datePosted: '2021-05-02',
  },
  {
    id: '1051',
    title: '1996 Mitsubishi Lancer Evolution IV',
    year: 1996,
    make: 'Mitsubishi',
    model: 'Lancer Evolution IV',
    mileage: '149,500 kms',
    price: 'Sold',
    description: '',
    features: [
      '2.0 Liter Turbo 4G63 Engine, AWD',
      '149,500 kms (92,900 miles)',
      'New stock Exedy clutch kit',
      'All fluids replaced — Redline trans, Diaqueen center diff, Mits ATF SPIII AYC, Valvoline 70W90 diff',
      'New starter, new spark plugs',
      'Qualifies for US import',
    ],
    issues: [
      'Paint faded / uneven color',
      'Undercarriage rust',
      'Driver quality car',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/04/dsc8307.jpg'],
    status: 'sold',
    datePosted: '2021-04-06',
  },
  {
    id: '943',
    title: '1996 Mitsubishi Lancer Evolution IV',
    year: 1996,
    make: 'Mitsubishi',
    model: 'Lancer Evolution IV',
    mileage: '155,400 kms',
    price: 'Sold',
    description: '',
    features: [
      '2.0 Liter Turbo 4G63 Engine, AWD',
      'Rust Free',
      'Coilovers — excellent grip in corners',
      'All bushings replaced with Powerflex — subframe, driveshaft etc.',
      'New Stage 2 clutch kit',
      'New spark plugs',
    ],
    issues: [
      'Wipers only work at 1 speed',
      'Accident history, Auction Grade R',
    ],
    images: ['https://jdm.net/wp-content/uploads/2022/03/screen-shot-2022-03-22-at-1.34.03-pm.png'],
    photoLink: 'https://photos.app.goo.gl/wtbxrBs7FwWmmXh66',
    status: 'sold',
    datePosted: '2021-01-14',
  },
  {
    id: '938',
    title: '1994 BMW 530i Touring',
    year: 1994,
    make: 'BMW',
    model: '530i Touring',
    mileage: '195,500 kms',
    price: 'Sold',
    description: '',
    features: [
      '1994 BMW 530i V8',
      'Clean Car inside and out with no underbody rust',
      'Accident free, original paint',
      'Runs and drives smooth at highway speeds',
    ],
    issues: [
      'Passenger side has been repainted',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/03/dsc7858.jpg'],
    status: 'sold',
    datePosted: '2021-01-14',
  },
  {
    id: '908',
    title: '1996 Mitsubishi Lancer Evolution IV',
    year: 1996,
    make: 'Mitsubishi',
    model: 'Lancer Evolution IV',
    mileage: '77,500 kms',
    price: 'Sold',
    description: '',
    features: [
      '2.0 Liter Turbo, 280 bhp',
      '77,500 original kms (48,150 miles)',
      'Clean Car with no underbody rust',
      'Accident free',
    ],
    issues: [
      'Japanese spec radio needs replacement',
    ],
    images: ['https://jdm.net/wp-content/uploads/2021/03/dsc8074.jpg'],
    status: 'sold',
    datePosted: '2020-12-17',
  },
  {
    id: '883',
    title: '2003 Audi RS6 Twin Turbo Avant',
    year: 2003,
    make: 'Audi',
    model: 'RS6 Avant',
    mileage: '88,500 kms',
    price: 'Sold',
    description: '',
    features: [
      '4.2 Liter V8, 444 bhp, Twin Turbo',
      '88,500 original kms (54,991 miles)',
      'Clean Car with no underbody rust',
      'Accident free, original paint, collector quality',
    ],
    issues: [
      'Radio/GPS is Japanese spec — needs North American replacement',
    ],
    images: ['https://jdm.net/wp-content/uploads/2020/11/dsc7894.jpg'],
    status: 'sold',
    datePosted: '2020-11-27',
  },
  {
    id: '846',
    title: '2003 Audi S3 Turbo AWD',
    year: 2003,
    make: 'Audi',
    model: 'S3',
    mileage: '91,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '4 Cyl Turbocharged, 225 hp, AWD',
      'Clean Car with no underbody rust',
      'Timing belt and water pump replaced',
      'New battery',
    ],
    issues: [
      'Front right fender and rear left quarter panel repainted',
    ],
    images: ['https://jdm.net/wp-content/uploads/2020/12/dsc7397.jpg'],
    status: 'sold',
    datePosted: '2020-10-15',
  },
  {
    id: '587',
    title: '2004 Audi RS6 Twin Turbo Wagon',
    year: 2004,
    make: 'Audi',
    model: 'RS6 Wagon',
    mileage: '68,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '4.2 Liter V8 Twin Turbo, 444 bhp',
      '68,000 original documented kms',
      'Clean Car with no underbody rust',
      'Accident free, original paint, collector quality',
    ],
    issues: [
      'Radio/GPS is Japanese spec — needs North American replacement',
    ],
    images: ['https://jdm.net/wp-content/uploads/2020/03/dsc_6416.jpg'],
    status: 'sold',
    datePosted: '2020-03-07',
  },
  {
    id: '570',
    title: '1991 BMW 325i Touring Wagon',
    year: 1991,
    make: 'BMW',
    model: '325i Touring Wagon',
    mileage: '142,100 kms',
    price: 'Sold',
    description: '',
    features: [
      'Clean Car with no underbody rust',
      'Full glass and trim-out repaint in original color',
      'New tires',
      'New control arms and tie rods',
      'A/C and heater works',
      'New headliner installed',
    ],
    issues: [
      'Door locks finicky',
      'Sunroof not working',
      'Front right fender replaced',
    ],
    images: ['https://jdm.net/wp-content/uploads/2020/02/dsc_6309.jpg'],
    status: 'sold',
    datePosted: '2020-02-12',
  },
  {
    id: '527',
    title: '2002 Audi S3',
    year: 2002,
    make: 'Audi',
    model: 'S3',
    mileage: '107,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '4 Cyl Turbocharged, 225 hp',
      '107,000 kms',
      'Clean Car with no underbody rust',
    ],
    issues: [
      'Front bumper repaired and repainted in transit',
      'Clear coat issue on right rear quarter panel',
      'Radio is Japanese spec',
    ],
    images: ['https://jdm.net/wp-content/uploads/2019/11/dsc_6475-1.jpg'],
    status: 'sold',
    datePosted: '2019-11-18',
  },
  {
    id: '498',
    title: '1995 BMW M3 EuroSpec 286hp',
    year: 1995,
    make: 'BMW',
    model: 'M3 EuroSpec',
    mileage: '120,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'S50B30 3.0L ITB Engine — 286 bhp',
      'Clean Car with no underbody rust',
      'New steering rack, tie rods (inner and outer)',
      'Oil change Mobil1 synthetic, spark plugs, ignition coils, strut and shock mounts',
      'ST Suspension coilovers',
      'Full respray in original color',
    ],
    issues: [
      'Clear coat issue on top of trunk',
      'Paint cracking on hood',
      'Japanese spec radio',
    ],
    images: ['https://jdm.net/wp-content/uploads/2019/09/dsc_6776.jpg'],
    status: 'sold',
    datePosted: '2019-09-29',
  },
  {
    id: '483',
    title: '1998 BMW M3 EuroSpec 321bhp S50B32',
    year: 1998,
    make: 'BMW',
    model: 'M3 EuroSpec',
    mileage: '152,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'S50B32 3.2L ITB Engine — 321 bhp, 6 Speed (converted from SMG)',
      'Beautiful Estoril Blue color',
      'Clean Car with no undercarriage rust',
      'New stock clutch kit, slave cylinder, clutch pedal assembly',
      'New shift rod, carrier and bushings',
      'New rear trailing arm bushings',
      'New spark plugs, ignition coils and boots',
      'New OEM 6 Speed shift knob',
      'Fully rebuilt dual Vanos with S62 diaphragm springs',
      'New front brake calipers, rotors and pads',
      'Perfect compression in all cylinders',
      'Full tune up — vacuum lines, breather hoses, intake gaskets etc.',
    ],
    issues: [
      'Rear brake rotors and pads need replacement',
      'Clutch slips at high load — flywheel noisy',
      'Suspension overhaul needed',
      'Rough idle',
    ],
    images: ['https://jdm.net/wp-content/uploads/2019/11/dsc_6501.jpg'],
    photoLink: 'https://photos.app.goo.gl/dop3MGVWnkXSeCs7A',
    status: 'sold',
    datePosted: '2019-09-04',
  },
  {
    id: '460',
    title: '2001 Audi S4 Avant Nogaro Blue',
    year: 2001,
    make: 'Audi',
    model: 'S4 Avant',
    mileage: '112,000 miles (180,000 kms)',
    price: 'Sold',
    description: '',
    features: [
      'Clean Car from Hawaii with no underbody rust',
      'Desirable Nogaro Blue color',
      'No Accidents, clean Carfax',
      '6 Speed Manual swapped',
      'Legal for export to USA (prior USA car)',
      'New clutch kit, master cyl, slave cyl, engine mounts, front axles, rebuilt rear axles, rear diff seals',
    ],
    issues: [],
    images: [],
    status: 'sold',
    datePosted: '2019-08-14',
  },
  {
    id: '440',
    title: '2018 BMW M4',
    year: 2018,
    make: 'BMW',
    model: 'M4',
    mileage: '31,700 kms',
    price: 'Sold',
    description: '',
    features: [
      'Clean Car in excellent condition',
      'Runs and Drives great',
    ],
    issues: [],
    images: [],
    status: 'sold',
    datePosted: '2019-08-14',
  },
  {
    id: '420',
    title: '1997 Alpina B3 3.2',
    year: 1997,
    make: 'Alpina',
    model: 'B3 3.2',
    mileage: '131,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'Alpina B3 3.2 Liter Engine — only 342 units built worldwide',
      '131,000 kms',
      'Clean Car with no underbody rust',
      'Runs and Drives great',
      'Auto swapped to 5 Speed manual',
    ],
    issues: [
      'Clear coat issues on rear spoiler',
      'Minor clear coat issue on front right fender from accident dent repair (still original fender panel)',
    ],
    images: ['/cars/dsc_4943.jpg', '/cars/alpina_b3_silver.jpg', '/cars/alpinab3_blue.jpg'],
    status: 'sold',
    datePosted: '2019-04-19',
  },
  {
    id: '400',
    title: '1991 Lancia Delta Integrale 16V HF Turbo',
    year: 1991,
    make: 'Lancia',
    model: 'Delta Integrale 16V HF Turbo',
    mileage: '98,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '1991 Lancia Delta Integrale 4×4 Turbo',
      '98,000 kms',
      'Clean Car with no underbody rust',
      'Runs and Drives great — pulls strong up to highway speeds',
      'Recent repaint in original Nero Black metallic',
      'New front wishbone bushings',
      'Mobil1 Synthetic Engine Oil 5W40, Valvoline Diff oil 70W90',
      'New Spark Plugs, wires, Distributor rotor and cap',
      'New Idle control valve',
      'New tires all around',
      'New front springs and shocks',
    ],
    issues: [
      'Could use new sideskirts as they are cracked',
    ],
    images: ['/cars/lancia-delta-integrale-1991.jpeg'],
    photoLink: 'https://photos.app.goo.gl/7ce3yWVaBGoRBqdy5',
    status: 'sold',
    datePosted: '2019-04-19',
  },
  {
    id: '380',
    title: '2008 BMW 128i',
    year: 2008,
    make: 'BMW',
    model: '128i',
    mileage: '206,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '230 bhp Inline 6 Cylinder motor',
      'Rear Wheel Drive',
      'Navigation and Bluetooth',
    ],
    issues: [],
    images: ['/cars/dsc_7149.jpg'],
    status: 'sold',
    datePosted: '2017-12-12',
  },
  {
    id: '360',
    title: '1990 Lancia Delta HF Integrale Turbo AWD 16v',
    year: 1990,
    make: 'Lancia',
    model: 'Delta HF Integrale Turbo AWD 16v',
    mileage: '81,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '200 bhp turbo motor with lots of power',
      'All Wheel Drive',
      'Beautiful Recaro Leather Seats',
      'Refinished Cromodora Rims with brand new Bridgestone RE71R tires',
    ],
    issues: [],
    images: ['/cars/dsc_7198.jpg'],
    status: 'sold',
    datePosted: '2017-09-29',
  },
  {
    id: '340',
    title: '1990 Lancia Delta HF Integrale 16v AWD Turbo',
    year: 1990,
    make: 'Lancia',
    model: 'Delta HF Integrale 16v AWD Turbo',
    mileage: '144,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '200 bhp turbo motor with lots of power',
      'All Wheel Drive',
      'Beautiful Cloth Velour seats',
    ],
    issues: [],
    images: ['/cars/20171009_104709.jpg'],
    status: 'sold',
    datePosted: '2017-09-29',
  },
  {
    id: '320',
    title: '1981 Panther Lima Turbo',
    year: 1981,
    make: 'Panther',
    model: 'Lima Turbo',
    mileage: '',
    price: 'Sold',
    description: '',
    features: [
      '2.3 Liter Turbo Engine (175 bhp)',
      'One of about 400 Turbo models',
      'In Authentic condition',
    ],
    issues: [],
    images: ['/cars/img_0145.jpg'],
    status: 'sold',
    datePosted: '2017-06-29',
  },
  {
    id: '310',
    title: '2008 Mitsubishi Lancer Evolution X Turbo AWD',
    year: 2008,
    make: 'Mitsubishi',
    model: 'Lancer Evolution X',
    mileage: '',
    price: 'Sold',
    description: '',
    features: [
      'Brand new Brakes on all 4 corners (Rotors and Pads)',
      'New Clutch',
      'Low Mileage for the year',
      'Mishimoto Aluminum Radiator',
      'Mishimoto Intercooler',
    ],
    issues: [],
    images: ['/cars/evo-8.jpg'],
    status: 'sold',
    datePosted: '2017-06-17',
  },
  {
    id: '290',
    title: '1988 BMW 325is M-Technic II',
    year: 1988,
    make: 'BMW',
    model: '325is M-Technic II',
    mileage: '88,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '88,000 kms',
      'Very Rare Original M Technic II',
    ],
    issues: [],
    images: [],
    status: 'sold',
    datePosted: '2017-05-27',
  },
  {
    id: '280',
    title: '2004 Mazda RX8',
    year: 2004,
    make: 'Mazda',
    model: 'RX8',
    mileage: '111,000 kms (68,000 miles)',
    price: 'Sold',
    description: '',
    features: [
      'Low 111,000 kms (68,000 miles)',
      'Imported from USA',
      'Leather Interior',
      'Bose Stereo System',
      'Clean Carproof Report',
      'Bridgestone tires all around with at least 80% tread',
      'NGK Spark plug wires',
    ],
    issues: [],
    images: ['/cars/rx8.jpg'],
    status: 'sold',
    datePosted: '2017-04-14',
  },
  {
    id: '270',
    title: '2009 Subaru WRX Hatchback Turbo',
    year: 2009,
    make: 'Subaru',
    model: 'WRX Hatchback',
    mileage: '194,000 kms',
    price: 'Sold',
    description: '',
    features: [
      '265 bhp turbo motor with lots of power',
      'Very clean car',
      'Clean Carproof Report with no accident history',
      'Runs smooth at highway speeds',
      'Extra set of winter tires and rims included',
      'Full Turboback Invidia Stainless Steel Exhaust',
    ],
    issues: [],
    images: ['/cars/dsc03081.jpg'],
    status: 'sold',
    datePosted: '2017-04-14',
  },
  {
    id: '260',
    title: '2000 Mitsubishi Evo Tommi Mäkinen Edition',
    year: 2000,
    make: 'Mitsubishi',
    model: 'Lancer Evolution TME',
    mileage: '105,000 kms',
    price: 'Sold',
    description: '',
    features: [
      'Original Red SCP (Special Coloring Package)',
      '105,000 kms',
      'Very rare and collectible',
      'Limited production',
      '286 hp Turbo Engine mated to a 5 Speed gearbox',
      'Rare Fog Light version bumper',
    ],
    issues: [],
    images: ['/cars/evo-red-tme-10.jpg'],
    status: 'sold',
    datePosted: '2017-04-14',
  },
  {
    id: '250',
    title: '1990 Mercedes 190E 2.5-16',
    year: 1990,
    make: 'Mercedes',
    model: '190E 2.5-16',
    mileage: '93,500 kms (59,000 miles)',
    price: 'Sold',
    description: '',
    features: [
      '2.5 Liter 16-valve engine (197 bhp, double row timing chain)',
      '5 Speed Dogleg Gearbox',
      '93,500 kms (59,000 miles)',
      'Clean Car with no underbody rust',
      'Runs and Drives great',
      'Classic collector car',
      'Rare Houndstooth interior',
      'Includes a set of 17″ AMG Wheels',
    ],
    issues: [],
    images: [],
    status: 'sold',
    datePosted: '2017-04-14',
  },
  {
    id: '240',
    title: '1994 BMW M3 Canadian EuroSpec — 40 of 45',
    year: 1994,
    make: 'BMW',
    model: 'M3 Canadian EuroSpec',
    mileage: '147,515 kms (91,661 miles)',
    price: 'Sold',
    description: '',
    features: [
      'Limited edition EuroSpec #40 of 45 sold new in Canada by BMW',
      '1 of 2 cars ordered with ALL options — including extended leather package',
      '3.0 Liter S50B30 EuroSpec 286 bhp Engine',
      '5 Speed transmission',
      'Limited Slip differential',
      'Rare classic collector car',
      'BMW Individual',
      'Certificate from BMW for US Safety and EPA/Emission regulations included',
      'Runs smooth, no vibrations at highway speeds',
      'New Tires all around',
    ],
    issues: [
      'Has been in a couple of accidents — still needs mechanical and body work to be perfect',
    ],
    images: [],
    status: 'sold',
    datePosted: '2017-04-14',
  },
];
